import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import baseConverterReducer from '../features/base_converter/BaseConverterSlice';
import bmiCalculatorReducer from '../features/bmi_calculator/BmiCalculatorSlice';
import distanceUnitConverterReducer from '../features/distance_unit_converter/DistanceUnitConverterSlice';
import faviconGeneratorReducer from '../features/favicon_generator/FaviconGeneratorSlice';
import temperatureConverterReducer from '../features/temperature_converter/TemperatureConverterSlice';
import weightUnitConverterReducer from '../features/weight_unit_converter/WeightUnitConverterSlice';
import compoundInterestCalculatorReducer from '../features/compound_interest_calculator/CompoundInterestCalculatorSlice';
import creditCardRepaymentCalculatorReducer from '../features/credit_card_repayment_calculator/CreditCardRepaymentCalculatorSlice';
import homeReducer from '../features/home/HomeSlice';
import sideMenuReducer from '../features/side_menu/SideMenuSlice';
import androidIosImageResizerReducer from '../features/android_ios_image_resizer/AndroidIosImageResizerSlice';
import pdfMergerReducer from '../features/pdf_merger/PdfMergerSlice';
import aboutUsReducer from '../features/about_us/AboutUsSlice';
import imageConverterReducer from '../features/image_converter/ImageConverterSlice';
import compressionReducer from '../features/compression/CompressionSlice';
import qrCodeGeneratorReducer from '../features/qr_code_generator/QrCodeGeneratorSlice';
import passwordGeneratorReducer from '../features/password_generator/PasswordGeneratorSlice';
import loremIpsumGeneratorReducer from '../features/lorem_ipsum_generator/LoremIpsumGeneratorSlice';
import barcodeGeneratorReducer from '../features/barcode_generator/BarcodeGeneratorSlice';
import csvJsonConverterReducer from '../features/csv_json_converter/CsvJsonConverterSlice';
import imageCropperReducer from '../features/image_cropper/ImageCropperSlice';
import emailSignatureGeneratorReducer from '../features/email_signature_generator/EmailSignatureGeneratorSlice';
import imageToPdfConverterReducer from '../features/image_to_pdf_converter/ImageToPdfConverterSlice';
import invoiceGeneratorReducer from '../features/invoice_generator/InvoiceGeneratorSlice';
import countdownTimerReducer from '../features/countdown_timer/CountdownTimerSlice';
import dateCalculatorReducer from '../features/date_calculator/DateCalculatorSlice';
import caseConverterReducer from '../features/case_converter/CaseConverterSlice';
import uuidGeneratorReducer from '../features/uuid_generator/UuidGeneratorSlice';
import base64EncoderReducer from '../features/base64_encoder/Base64EncoderSlice';
import jwtDecoderReducer from '../features/jwt_decoder/JwtDecoderSlice';
import jsonToCSharpReducer from '../features/json_to_csharp/JsonToCSharpSlice';
import timezoneConverterReducer from '../features/timezone_converter/TimezoneConverterSlice';
import pdfCompressionReducer from '../features/pdf_compression/PdfCompressionSlice';

export const store = configureStore({
  reducer: {
    baseConverter: baseConverterReducer,
    bmiCalculator: bmiCalculatorReducer,
    distanceUnitConverter: distanceUnitConverterReducer,
    weightUnitConverter: weightUnitConverterReducer,
    faviconGenerator: faviconGeneratorReducer,
    temperatureConverter: temperatureConverterReducer,
    compoundInterestCalculator: compoundInterestCalculatorReducer,
    creditCardRepaymentCalculator: creditCardRepaymentCalculatorReducer,
    home: homeReducer,
    sideMenu: sideMenuReducer,
    androidIosImageResizer: androidIosImageResizerReducer,
    pdfMerger: pdfMergerReducer,
    aboutUs: aboutUsReducer,
    imageConverter: imageConverterReducer,
    compression: compressionReducer,
    qrCodeGenerator: qrCodeGeneratorReducer,
    passwordGenerator: passwordGeneratorReducer,
    loremIpsumGenerator: loremIpsumGeneratorReducer,
    barcodeGenerator: barcodeGeneratorReducer,
    csvJsonConverter: csvJsonConverterReducer,
    imageCropper: imageCropperReducer,
    emailSignatureGenerator: emailSignatureGeneratorReducer,
    imageToPdfConverter: imageToPdfConverterReducer,
    invoiceGenerator: invoiceGeneratorReducer,
    countdownTimer: countdownTimerReducer,
    dateCalculator: dateCalculatorReducer,
    caseConverter: caseConverterReducer,
    uuidGenerator: uuidGeneratorReducer,
    base64Encoder: base64EncoderReducer,
    jwtDecoder: jwtDecoderReducer,
    jsonToCSharp: jsonToCSharpReducer,
    timezoneConverter: timezoneConverterReducer,
    pdfCompression: pdfCompressionReducer,
  }, middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['CompressionSlice.ts'],
      }
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
